export const consts = {
  adminURL: "https://admin.videolink.app",
  agentURL: "https://agent.videolink.app",
  status_token_already_exist: "token already valid",
  statys_token_not_found: "token no exist",
  mode_contact: "contact",
  mode_attentions: "attentions",
  
};
